module.exports = __webpack_public_path__ + "img/logo.c3db64ec.png";